export default class TranslationMap {
    private texts: { [key: string]: string };

    constructor(texts?: { [key: string]: string }) {
        this.texts = texts || {};
    }

    get(id: string) {
        return this.texts[id] || id;
    }

    getOrDefault(id: string, fallback: string | null): string | null {
        return this.texts[id] || fallback;
    }
}
